import { TOrderChecklistActions } from './order-checklist.action';
import { TOrderChecklistActionType, TOrderChecklistState } from './order-checklist.models';

export const ORDER_CHECKLIST_ITEMS_PER_PAGE_LIST = [10, 100, 150, 200];

export const initialState: TOrderChecklistState = {
  orderChecklistInfo: null,
  userPaginationOption: {
    pageNo: 1,
    pageSize: ORDER_CHECKLIST_ITEMS_PER_PAGE_LIST[0],
  },
  orderChecklistSelectedFilters: null,
};

export function orderChecklistReducer(state = initialState, action: TOrderChecklistActions): TOrderChecklistState {
  switch (action.type) {
    case TOrderChecklistActionType.GetOrderChecklistSuccess:
      return {
        ...state,
        orderChecklistInfo: action.orderChecklistRes,
      };
    case TOrderChecklistActionType.SetUserPaginationOption:
      return {
        ...state,
        userPaginationOption: action.userPaginationOption,
      };
    case TOrderChecklistActionType.SetOrderChecklistSelectedFilters:
      return {
        ...state,
        orderChecklistSelectedFilters: action.filterModel,
      };
    default:
      return state;
  }
}
